<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="-mb-16px">
        <el-form
          ref="searchRefs"
          :model="search"
          size="small"
          label-width="76px"
          inline
        >
          <el-form-item label="线索ID" prop="clue_id">
            <el-input
              v-model="search.clue_id"
              clearable
              placeholder="请输入线索ID"
              style="width: 160px"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属站点" prop="site_id">
            <el-select
              v-model="search.site_id"
              filterable
              clearable
              placeholder="全部站点"
              style="width: 300px"
            >
              <el-option label="全部站点" value=""></el-option>
              <el-option
                v-for="item in siteOptions"
                :key="item.id"
                :label="siteOptionLabel(item)"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日志类型" prop="event_type">
            <el-select
              v-model="search.event_type"
              clearable
              placeholder="全部类型"
              style="width: 130px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="屏蔽" value="blocked"></el-option>
              <el-option label="失败" value="failed"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="触发方式" prop="attempt_type">
            <el-select
              v-model="search.attempt_type"
              clearable
              placeholder="全部方式"
              style="width: 130px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="自动转发" value="automatic"></el-option>
              <el-option label="手动转发" value="manual"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键词" prop="keyword">
            <el-input
              v-model="search.keyword"
              clearable
              placeholder="原因/命中词"
              style="width: 190px"
            ></el-input>
          </el-form-item>
          <el-form-item label="记录时间" prop="date_range">
            <el-date-picker
              v-model="search.date_range"
              type="daterange"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 260px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="ml-6px">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="mt-16px" v-loading="pager.loading" shadow="never">
      <el-alert
        class="mb-16px"
        title="这里只记录被过滤关键词屏蔽、SMTP 转发失败的异常线索；转发成功不会记录。"
        type="info"
        show-icon
        :closable="false"
      ></el-alert>
      <div class="data-table-scroll" style="--table-min-width: 1640px">
        <el-table :data="pager.list">
          <el-table-column
            prop="id"
            label="日志ID"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="clue_id"
            label="线索ID"
            width="90"
          ></el-table-column>
          <el-table-column label="站点" min-width="180" show-overflow-tooltip>
            <template v-slot="scope">
              <div>{{ scope.row.site_name || "-" }}</div>
              <small class="muted">{{ scope.row.site_url || "-" }}</small>
            </template>
          </el-table-column>
          <el-table-column label="日志类型" width="100">
            <template v-slot="scope">
              <el-tag
                size="small"
                :type="scope.row.event_type === 'failed' ? 'danger' : 'warning'"
              >
                {{ eventTypeLabel(scope.row.event_type) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="触发方式" width="100">
            <template v-slot="scope">
              <el-tag
                size="small"
                :type="scope.row.attempt_type === 'manual' ? 'success' : 'info'"
              >
                {{ attemptTypeLabel(scope.row.attempt_type) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="手动转发" width="120">
            <template v-slot="scope">
              <el-tag
                size="small"
                :type="manualForwardTagType(scope.row.manual_forward_status)"
              >
                {{ manualForwardStatusLabel(scope.row.manual_forward_status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作人" width="130" show-overflow-tooltip>
            <template v-slot="scope">
              {{ scope.row.manual_forward_admin_account || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="操作时间" width="160">
            <template v-slot="scope">
              <span v-if="scope.row.manual_forward_time">
                {{
                  formatDate(
                    scope.row.manual_forward_time,
                    "yyyy-mm-dd hh:MM:ss"
                  )
                }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="matched_keyword"
            label="命中关键词"
            width="150"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              {{ scope.row.matched_keyword || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="reason_message"
            label="异常原因"
            min-width="280"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              {{ scope.row.reason_message || scope.row.reason_code || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="记录时间" width="160">
            <template v-slot="scope">
              {{ formatDate(scope.row.create_time, "yyyy-mm-dd hh:MM:ss") }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template v-slot="scope">
              <el-button type="text" @click="onDetail(scope.row.clue_id)">
                查看线索
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex justify-between mt-16px">
        <div class="flex"></div>
        <pagination
          v-model="pager"
          :pageSizes="[10, 20, 30]"
          @change="getList()"
        ></pagination>
      </div>
    </el-card>

    <edit-dialog ref="popupRefs" @refresh="getList"></edit-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/pagination";
import { Pager } from "@/utils/pager";
import { apiClueDeliveryLogList } from "@/api/clue";
import { apiSiteOptions } from "@/api/site";
import EditDialog from "@/views/clue/clue/dialog.vue";
import { formatDate } from "@/utils/util";

const defaultSearch = () => ({
  clue_id: "",
  site_id: "",
  event_type: "",
  attempt_type: "",
  keyword: "",
  date_range: [],
});

export default {
  components: {
    EditDialog,
    Pagination,
  },
  data() {
    return {
      search: defaultSearch(),
      siteOptions: [],
      pager: new Pager(),
    };
  },
  created() {
    this.getSiteOptions();
    this.getList();
  },
  methods: {
    formatDate,
    getSiteOptions() {
      apiSiteOptions().then((resp) => {
        this.siteOptions = resp || [];
      });
    },
    siteOptionLabel(site) {
      const name = site.name || "未命名站点";
      const url = site.url || "-";
      return `${name} - ${url}`;
    },
    onSearch() {
      this.getList(1);
    },
    onReset() {
      Object.assign(this.search, defaultSearch());
      this.$refs.searchRefs && this.$refs.searchRefs.clearValidate();
      this.getList(1);
    },
    getList(page) {
      page && (this.pager.page = page);
      this.pager.request({
        callback: apiClueDeliveryLogList,
        params: this.buildRequestParams(),
      });
    },
    buildRequestParams() {
      const query = {
        clue_id: this.search.clue_id,
        site_id: this.search.site_id,
        event_type: this.search.event_type,
        attempt_type: this.search.attempt_type,
        keyword: this.search.keyword,
      };
      if (this.search.date_range && this.search.date_range.length === 2) {
        query.start_time = Math.floor(Number(this.search.date_range[0]) / 1000);
        query.end_time =
          Math.floor(Number(this.search.date_range[1]) / 1000) + 86399;
      }
      Object.keys(query).forEach((key) => {
        if (
          query[key] === "" ||
          query[key] === undefined ||
          query[key] === null
        ) {
          delete query[key];
        }
      });
      return query;
    },
    eventTypeLabel(value) {
      return (
        {
          blocked: "屏蔽",
          failed: "失败",
        }[value] || "未知"
      );
    },
    attemptTypeLabel(value) {
      return (
        {
          automatic: "自动转发",
          manual: "手动转发",
        }[value] || "未知"
      );
    },
    manualForwardStatusLabel(value) {
      return (
        {
          0: "未处理",
          1: "已加入队列",
          2: "已成功",
          3: "失败",
        }[Number(value || 0)] || "未处理"
      );
    },
    manualForwardTagType(value) {
      return (
        {
          0: "info",
          1: "warning",
          2: "success",
          3: "danger",
        }[Number(value || 0)] || "info"
      );
    },
    onDetail(id) {
      this.$refs.popupRefs.openDialog(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.muted {
  display: block;
  margin-top: 2px;
  color: #8a97aa;
  line-height: 18px;
}
</style>
